import { render, staticRenderFns } from "./sidebar-lg.vue?vue&type=template&id=111d6b12&scoped=true"
import script from "./sidebar-lg.vue?vue&type=script&lang=ts"
export * from "./sidebar-lg.vue?vue&type=script&lang=ts"
import style0 from "./sidebar-lg.vue?vue&type=style&index=0&id=111d6b12&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111d6b12",
  null
  
)

export default component.exports